const MAX_PAGE_LIMIT = 100;
const MIN_PAGE_LIMIT = 1;

export const normalizePageParams = <T extends { limit?: number }>(params: T): T => {
  if (typeof params.limit !== 'number' || Number.isNaN(params.limit)) {
    return params;
  }

  return {
    ...params,
    limit: Math.min(Math.max(params.limit, MIN_PAGE_LIMIT), MAX_PAGE_LIMIT),
  };
};
